export default __webpack_public_path__ + "static/media/customize1.74053666.webp";